import { Observable } from 'rxjs';
import { FileModel, FilesApi } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export class MockFilesApi extends FilesApi {
  files: FileModel[] = [];

  getAllFiles(includeAudioUrls?: boolean, filter?: string): Observable<any> {
    return mockHandler(this.files);
  }

}
